import gql from 'graphql-tag';

const DELETE_MANY_NOTIFICATIONS_BY_USER = gql`
  mutation deleteManyNotificationsByUser($userId: ID!) {
    deleteManyNotifications(where: { user: { id: $userId } }) {
      count
    }
  }
`;

export default DELETE_MANY_NOTIFICATIONS_BY_USER;
